define('models/template/template',[
    'underscore', 'backbone', 'utils',
    // services
    'services/api',
    // models & collections
    'collections/template/calendar/template-calendar-days',
    'collections/template/calendar/template-sessions',
], function(
    _, Backbone, U,
    // services
    API,
    // models & collections
    CTemplateCalendarDays,
    CTemplateSession
) {

    var MTemplate = Backbone.Model.extend({
        idAttribute: '_id',
        titleAttribute: 'name',
        blacklist: ['_editable', 'owner', 'group'],
        dayItemBlacklist: ['done', 'feedback_level', 'feedback_comment', 'group', '_id', 'date'],

        urlRoot: function() {
            // templates must be created via group
            if (this.isNew()) {
                return API.url('groups/' + this.get('group') + '/templates/');
            }
            return API.url("templates/");
        },

        defaults: function() {
            return {
                days: this.getDefaultDays(),
                name: "",
                description: "",
                sharedToSubgroups: false,
                autoAssignChoice: false,
                sessions: new CTemplateSession()
            };
        },

        parse: function(data, options) {
            if (data.days) this.parseDays(data);
            if (data.sessions) this.parseSessions(data);
            return data;
        },

        parseDays: function(data) {
            data.days = new CTemplateCalendarDays(
                _.map(data.days, function(day, dayIndex) {
                    return _.extend({}, {
                        _id: dayIndex,
                        items: _.map(day, function(item, itemIndex) {
                            return _.extend(item, {
                                dayId: dayIndex,
                                _id: _.uniqueId('item')
                            });
                        })
                    });
                }));

            // Adding days to get a full week + 2 extra blank weeks
            var daysCount = data.days.length,
                daysToAdd = 7 - daysCount % 7 + 14;

            for (var i = 0; i < daysToAdd; i++) {
                data.days.add({
                    _id: daysCount,
                    items: []
                });
                daysCount++;
            }
        },

        parseSessions: function(data) {
            data.sessions = new CTemplateSession(_.values(_.mapObject(data.sessions, function(session, key) {
                return _.extend({}, session, { _id: key });
            })));
        },

        unparseSessions: function() {
            var sessions = {};

            this.getSessions().each(function(session) {
                sessions[session.id] = this.sanitizeSession(session);
            }, this);

            return this.set('sessions', sessions);
        },

        unparseDays: function(items) {
            var days = [],
                sanitizedItems = this.getSanitizedItems(items);

            this.getDays().each(function(day, index) {
                days[index] = _.map(sanitizedItems.where({ dayId: day.id }), function(item) {
                    return item.omit('dayId');
                });
            });

            return this.set('days', days);
        },

        sanitizeNutrilogItem: function(item) {
            var entries = item.getEntries() || [];
            item.set('entries', entries.map(function(entry) {
                return _.omit(entry, '_food');
            }));
        },

        sanitizeSession: function(session) {
            session.set('exercises', session.getExerciseCollection().map(function(exercise) {
                var blacklist = _.result(exercise, 'blacklist', []);
                return exercise.omit(blacklist);
            }));
            return session.omit(['_id', 'dayId', '_date']);
        },

        getSanitizedItems: function(items) {
            items.each(function(item) {
                var blacklist = _.result(item, 'blacklist', []).concat(this.dayItemBlacklist),
                    itemCopy = item.clone();

                if (item.getType() === 'nutrilog') {
                    this.sanitizeNutrilogItem(itemCopy);
                }

                item.clear().set(itemCopy.omit(blacklist));
            }, this);

            return items;
        },

        getDefaultDays: function() {
            var days = [];
            for (var i = 0; i < 28; i++) {
                days.push({
                    _id: i,
                    items: [],
                });
            }
            return new CTemplateCalendarDays(days);
        },

        getDays: function() {
            return this.get('days');
        },

        getSessions: function() {
            return this.get('sessions');
        },
    });

    // Return the model for the module
    return MTemplate;
});

